import {
  IconButton,
  Menu,
  MenuButton,
  MenuContent,
  MenuItem,
  MoreIcon,
  ConfirmAlertDialog
} from '@woorcs/design-system'
import { ReactElement, useState, memo } from 'react'
import { useTranslation } from 'react-i18next'

import { EditUserModal } from '../../EditUserModal'
import { UserListUserFragment } from '../__generated__/UserListFragments'

type ConfirmRemoveAlertProps = {
  user: UserListUserFragment
  onConfirm(): void
  children: ReactElement
}

type ConfirmDisableAlertProps = {
  user: UserListUserFragment
  onConfirm(): void
  children: ReactElement
  disabled: boolean
  confirmLabel: string
}

const ConfirmRemoveAlert = memo(
  ({ user, onConfirm, children }: ConfirmRemoveAlertProps) => {
    return (
      <ConfirmAlertDialog
        title={`Ta bort \`${user.firstName} ${user.lastName}\``}
        body='Är du säker på att du vill ta bort den här användaren?'
        confirmLabel='Ta bort'
        onConfirm={onConfirm}
      >
        {children}
      </ConfirmAlertDialog>
    )
  }
)

type UserRowMenuProps = {
  user: UserListUserFragment
  isViewer: boolean
  onRemove(): void
  onDisable(): void
}

export const UserRowMenu = memo(
  ({ user, isViewer, onRemove }: UserRowMenuProps) => {
    const { t } = useTranslation()
    const [visible, setVisible] = useState(false)

    return (
      <Menu placement='bottom-end' open={visible} setOpen={setVisible}>
        <MenuButton>
          <IconButton color='primary' display='inline-flex'>
            <MoreIcon />
          </IconButton>
        </MenuButton>

        <MenuContent aria-label='User menu'>
          <EditUserModal key={user.id} user={user}>
            <MenuItem hideOnClick={false}>{t('common:edit')}</MenuItem>
          </EditUserModal>
          {!isViewer && (
            <>
              <ConfirmRemoveAlert user={user} onConfirm={onRemove}>
                <MenuItem hideOnClick={false} destructive>
                  {t('common:remove')}
                </MenuItem>
              </ConfirmRemoveAlert>
            </>
          )}
        </MenuContent>
      </Menu>
    )
  }
)
